module.exports = __webpack_public_path__ + "images/accents/accent-review-resolve@2x-df05658e803ed59c80fd8b41c5715f70.webp";